import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const PublicRoute = () => {
  const { isAuthenticated, loading, user } = useAuth();

  // If still loading, don't do anything (or show a loading spinner)
  if (loading) {
    return null; // or return a loading spinner
  }

  // If user is authenticated, redirect to home
  // Otherwise, render the public route (e.g., login page)
  if (isAuthenticated) {
    const role = user?.role?.toLowerCase?.();
    if (role === "admin") return <Navigate to="/" replace />;
    return <Navigate to="/" replace />;
  }
  return <Outlet />;
};

export default PublicRoute;
